import { render } from "./side_pop_up.vue?vue&type=template&id=7206d530"
import script from "./side_pop_up.js?vue&type=script&lang=js"
export * from "./side_pop_up.js?vue&type=script&lang=js"

import "./side_pop_up.vue?vue&type=style&index=0&id=7206d530&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__